import { trackClientEvent } from 'analytics/analytics'
import type {
  ThereNoPlaceLikeHomePopupActionDestination,
  ThereNoPlaceLikeHomePopupMarket,
  ThereNoPlaceLikeHomePopupVariant,
} from './thereNoPlaceLikeHomePopupConfig'

type ThereNoPlaceLikeHomePopupActionTarget = 'trip_planner' | 'map_selection' | 'destination_search' | 'close' | 'remind_me_next_time'

const TRACKING_CATEGORY = 'homepage_there_no_place_like_home_popup'
const TRACKING_SUBJECT = 'there_no_place_like_home_popup'

function getMarketTrackingLabel(market: ThereNoPlaceLikeHomePopupMarket): string {
  return market === 'nsw' ? 'New South Wales' : 'Victoria'
}

function getActionTarget(actionDestination: ThereNoPlaceLikeHomePopupActionDestination): ThereNoPlaceLikeHomePopupActionTarget {
  if (actionDestination.type === 'chatPrompt') {
    return 'trip_planner'
  }

  if (actionDestination.path === '/search/map') {
    return 'map_selection'
  }

  return 'destination_search'
}

function buildAction(
  action: string,
  market: ThereNoPlaceLikeHomePopupMarket,
  variant: ThereNoPlaceLikeHomePopupVariant,
  details?: string,
): string {
  return [
    action,
    `market: ${getMarketTrackingLabel(market)}`,
    `variant: ${variant}`,
    details,
  ].filter(Boolean).join(' | ')
}

export function trackThereNoPlaceLikeHomePopupOpened(market: ThereNoPlaceLikeHomePopupMarket, variant: ThereNoPlaceLikeHomePopupVariant) {
  trackClientEvent({
    subject: TRACKING_SUBJECT,
    action: buildAction('opened', market, variant),
    category: TRACKING_CATEGORY,
    type: 'nonInteraction',
  })
}

export function trackThereNoPlaceLikeHomePopupActionClicked(
  market: ThereNoPlaceLikeHomePopupMarket,
  variant: ThereNoPlaceLikeHomePopupVariant,
  actionDestination: ThereNoPlaceLikeHomePopupActionDestination,
  buttonText: string,
) {
  trackClientEvent({
    subject: TRACKING_SUBJECT,
    action: buildAction(
      'clicked',
      market,
      variant,
      `target: ${getActionTarget(actionDestination)} | button: ${buttonText}`,
    ),
    category: TRACKING_CATEGORY,
    type: 'interaction',
  })
}

export function trackThereNoPlaceLikeHomePopupCloseClicked(
  market: ThereNoPlaceLikeHomePopupMarket,
  variant: ThereNoPlaceLikeHomePopupVariant,
  buttonText: string,
) {
  trackClientEvent({
    subject: TRACKING_SUBJECT,
    action: buildAction('clicked', market, variant, `target: close | button: ${buttonText}`),
    category: TRACKING_CATEGORY,
    type: 'interaction',
  })
}

export function trackThereNoPlaceLikeHomePopupRemindMeNextTimeClicked(
  market: ThereNoPlaceLikeHomePopupMarket,
  variant: ThereNoPlaceLikeHomePopupVariant,
  buttonText: string,
) {
  trackClientEvent({
    subject: TRACKING_SUBJECT,
    action: buildAction('clicked', market, variant, `target: remind_me_next_time | button: ${buttonText}`),
    category: TRACKING_CATEGORY,
    type: 'interaction',
  })
}
